import React from "react";
import styles from "./index.module.scss";
import Link from "next/link";
const Chat = ({ chatUrl }) => {
  return (
    <div className={styles.wrapper}>
      <Link className="koh-fixed-find-store-btn" href="/storelocator">
        <span className="icon koh-icon-envelope"></span>
        <span className="find-store-text">Find A Store</span>
      </Link>
      <a className="kohWhatsAppBtn" href={chatUrl} target="_blank">
        <span className="icon koh-icon-envelope"></span>
        <span className="chat-btn-text">Chat</span>
      </a>
    </div>
  );
};

export default Chat;
